// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"DeviceInfo_contentContainer__2p_j6","title":"DeviceInfo_title__1D7Za","subtitle":"DeviceInfo_subtitle__1aev2"};